import React, {useContext} from 'react';
import classnames from 'classnames';
import GuideContext from "../GuideContext";
import ReactSVG from 'react-svg';
import {useDispatch, logout, NeuroMessage} from "@ignitesales/neuro-application";

const Footer = ({user, children}) => {
  const dispatch = useDispatch();
  const guideContext = useContext(GuideContext);
  const employee = user && user.assignment && user.assignment.employee ? user.assignment.employee : null;
  const branch = user && user.assignment && user.assignment.branch ? user.assignment.branch.name : null;

  const onLogout = () => {
    dispatch( logout() );
  };

  const { isBranchGuide } = useContext(GuideContext);
  const bemClass = 'footer';
  const contentClasses = classnames(`${bemClass}`, {
    [`${bemClass}__branch`]: isBranchGuide,
    [`${bemClass}__online`]: !isBranchGuide,
  });

  return <footer className={contentClasses}>
    {children}
    <p className={`${bemClass}__content`}>
      <NeuroMessage id="footer.copyright" tagName="span"/>
      <ReactSVG src="/classpath/assets/images/icon-equal-housing.svg" wrapper="span" />
      <NeuroMessage id="footer.copyrightTwo" tagName="span"/>
      { employee && guideContext.isBranchGuide ?
        <a href='#!' className='footer__logout' onClick={onLogout}>
          { `${employee.firstName} ${employee.lastName}` } | { branch } | <NeuroMessage id='logout'/>
        </a>
        : null
      }
    </p>
  </footer>;
};

export default Footer;
